// Autocompletado del buscador del hero usando la API de búsqueda predictiva de Shopify.
document.addEventListener('DOMContentLoaded', function () {
  var input = document.getElementById('predictive-search-input');
  var resultsBox = document.getElementById('predictive-search-results');
  var form = document.getElementById('predictive-search-form');
  if (!input || !resultsBox || !form) return;

  var debounceTimer;

  function closeResults() {
    resultsBox.hidden = true;
    resultsBox.innerHTML = '';
  }

  function renderResults(data) {
    var products = (data.resources && data.resources.results && data.resources.results.products) || [];
    if (products.length === 0) {
      closeResults();
      return;
    }
    resultsBox.innerHTML = products.slice(0, 6).map(function (p) {
      var img = p.featured_image ? p.featured_image.url : '';
      return '<a class="predictive-search__item" href="' + p.url + '">' +
        (img ? '<img src="' + img + '&width=80" alt="">' : '<span class="predictive-search__ph">🌿</span>') +
        '<span class="predictive-search__item-info"><strong>' + p.title + '</strong><span>' + p.price + '</span></span>' +
        '</a>';
    }).join('') + '<a class="predictive-search__viewall" href="/search?q=' + encodeURIComponent(input.value) + '&type=product">Ver todos los resultados →</a>';
    resultsBox.hidden = false;
  }

  input.addEventListener('input', function () {
    var q = input.value.trim();
    clearTimeout(debounceTimer);
    if (q.length < 2) {
      closeResults();
      return;
    }
    debounceTimer = setTimeout(function () {
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,tag')
        .then(function (res) { return res.json(); })
        .then(renderResults)
        .catch(function () { closeResults(); });
    }, 250);
  });

  document.addEventListener('click', function (e) {
    if (!form.contains(e.target)) closeResults();
  });

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeResults();
  });
});
